import React from "react";

const CommonTextField = ({
  title,
  placeholder,
  type,
  value,
  onChange,
  suffixIcon = null,
  showPassword = null,
}) => {
  return (
    <>
      <p className="text-sm font-normal mb-1">{title}</p>
      <div className="flex flex-row items-center w-full rounded-lg mb-2 border border-[#5153F5]">
        <input
          placeholder={placeholder ?? title}
          type={showPassword == true ? "text" : type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="font-medium px-3 py-2 rounded-lg w-full"
        />
        <div className="flex-1" />
        {suffixIcon}
      </div>
    </>
  );
};

export default CommonTextField;
